export var mapCinchCareOrderToVehicle = function(cinchCarePlan, allVehicleOrders) {
    var ref;
    return {
        plan: cinchCarePlan,
        vehicle: (ref = allVehicleOrders === null || allVehicleOrders === void 0 ? void 0 : allVehicleOrders.find(function(order) {
            return order.vehicle.vrm === cinchCarePlan.vehicleVrm;
        })) === null || ref === void 0 ? void 0 : ref.vehicle
    };
};
